import AccountsTable from "./table";

const Accounts = () => {
  return <AccountsTable />;
};

export default Accounts;
